import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../base/_base-http.service';
import { Config } from '../config/env.config';
import { contentHeaders } from 'common/headers';
import * as moment from 'moment-timezone';
import {catchError, map} from 'rxjs/operators';
import * as _ from 'lodash';


@Injectable()
export class PreferencesService extends BaseHttpService {

  private preferences: any;

  getPreferences(): Observable<any> {
    return new Observable(observer => {
      if (this.preferences && !_.isString(this.preferences)) { // not error string
        observer.next(this.preferences);
        return observer.complete();
      } else {
        this.http.get(Config.API + '/user/preferences')

            .pipe(catchError(this.handleError.bind(this)))
          .subscribe((preferences: any) => {
            this.preferences = preferences;

            // if no timezone was set - guess it
            if (!this.preferences.timezone) {
              this.preferences.timezone = moment.tz.guess();
            }

            observer.next(this.preferences);
            observer.complete();
          });
      }
    });
  }

  putPreferences(data: any): Observable<any> {
    const body = JSON.stringify(data);
    return this.http.put(Config.API + '/user/preferences', body, {headers: contentHeaders})
      .pipe(map((res: any) => {
        if (res.success) {
          // update current preferences
          if (data.timezone) { this.preferences.timezone = data.timezone; }
        }
      }),
      catchError(this.handleError.bind(this)));
  }
}
